var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationForum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "26px",
    viewBox: "0 0 18 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationForum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.34,560.76 C34.6866183,560.76 30.84,564.161955 30.84,569.044359 C30.84,570.812455 31.3474406,572.703863 32.168125,574.126194 L38.7890741,585.603494 C38.8999913,585.798796 39.1109652,585.92 39.34,585.92 C39.5690348,585.92 39.7800087,585.798796 39.8909259,585.603494 L46.511875,574.126194 C47.3325909,572.703801 47.84,570.812455 47.84,569.044359 C47.84,564.161955 43.9933817,560.76 39.34,560.76 Z M39.34,561.987312 C43.3799965,561.987312 46.5807407,564.776102 46.5807407,569.044359 C46.5807407,570.574234 46.1000972,572.32616 45.4100231,573.522142 L39.34,584.040574 L33.2699769,573.522142 C32.5799343,572.326222 32.0992593,570.574234 32.0992593,569.044359 C32.0992593,564.776102 35.3000035,561.987312 39.34,561.987312 Z M39.34,565.055592 C37.0871726,565.055592 35.2474074,566.848725 35.2474074,569.044359 C35.2474074,571.24002 37.0871789,573.03312 39.34,573.03312 C41.5928211,573.03312 43.4325926,571.24002 43.4325926,569.044359 C43.4325926,566.848725 41.5928274,565.055592 39.34,565.055592 Z M39.34,566.282904 C40.9122544,566.282904 42.1733333,567.512029 42.1733333,569.044359 C42.1733333,570.576719 40.9122607,571.805811 39.34,571.805811 C37.7677393,571.805811 36.5066667,570.576719 36.5066667,569.044359 C36.5066667,567.512029 37.7677456,566.282904 39.34,566.282904 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forum-Location_HomePage",
    transform: "translate(-30.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLocationForum",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationForum);
export default __webpack_public_path__ + "static/media/icLocationForum.642e62c80ae7207cf9b95aedb9b87ebf.svg";
export { ForwardRef as ReactComponent };